var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSinglechoiceboxes = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "singlechoiceboxes_svg__Segmented",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "singlechoiceboxes_svg__Group-3",
  transform: "translate(4.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "singlechoiceboxes_svg__Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.9382197,1.42000579 L4.9382197,6.28333422 L1.18702628,6.28333422 C1.1860632,6.27973052 1.18532238,6.2750065 1.18532238,6.26919951 L1.18532238,1.4333376 C1.18532238,1.42796006 1.18604468,1.42349745 1.18698923,1.42000579 L4.9382197,1.42000579 Z M14.8146776,1.4333376 L14.8146776,6.27002108 C14.8146776,6.27539862 14.8139553,6.27986122 14.8129922,6.28333422 L11.0617618,6.28333422 L11.0617618,1.42000579 L14.8129922,1.42000579 C14.8139553,1.42349745 14.8146776,1.42796006 14.8146776,1.4333376 L14.8146776,1.4333376 Z M14.9628429,0 L1.03715708,0 C0.465257553,0 0,0.570000219 0,1.27062977 L0,6.40935156 C0,7.10998111 0.465257553,7.68 1.03715708,7.68 L14.9628429,7.68 C15.5347424,7.68 16,7.10998111 16,6.40935156 L16,1.27062977 C16,0.570000219 15.5347424,0 14.9628429,0 L14.9628429,0 Z"
})))));
export default SvgSinglechoiceboxes;